import { render, staticRenderFns } from "./ddzqhz.vue?vue&type=template&id=29f2ba33&scoped=true&"
import script from "./ddzqhz.vue?vue&type=script&lang=js&"
export * from "./ddzqhz.vue?vue&type=script&lang=js&"
import style0 from "./ddzqhz.vue?vue&type=style&index=0&id=29f2ba33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f2ba33",
  null
  
)

export default component.exports